import { render } from "./CodingSimulationPanel.vue?vue&type=template&id=5a86e682&scoped=true"
import script from "./CodingSimulationPanel.vue?vue&type=script&lang=js"
export * from "./CodingSimulationPanel.vue?vue&type=script&lang=js"

import "./CodingSimulationPanel.vue?vue&type=style&index=0&id=5a86e682&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a86e682"]])

export default __exports__